<template>
	<div class="site-works">
		<InfoRow
			v-for="(work, workIndex) in modelWorks"
			:key="`priceIndex=${workIndex}`"
			:title="$getDeep(work.work_type_id, works)"
			class="site-works__row"
		>
			<div class="site-works__inputs vx-row items-center">

				<div class="site-works__input d-flex vx-col w-full md:w-1/3 py-2 md:py-0">
					<vs-checkbox
						v-model="work.is_enabled_for_junior"
						class="w-full md:w-1/3"
					>{{ $t('showForJunior') }}</vs-checkbox>
					<vs-checkbox
						v-model="work.is_price_native"
						class="w-full md:w-1/3"
					>{{ $t('showForNative') }}</vs-checkbox>
					<vs-input
						v-model="work.native_price"
						type="number"
						name="native-price"
						:label="$t('priceForNative')"
						class="w-1/3 ml-1"
					/>
				</div>
				<div class="site-works__input d-flex vx-col w-full md:w-1/3 py-2 md:py-0">
					<vs-checkbox
						v-model="work.is_enabled_for_middle"
						class="w-full md:w-1/2"
					>{{ $t('showForMiddle') }}</vs-checkbox>
          			<vs-input
						v-model="work.middle_price"
            			type="number"
						name="middle-price"
						:label="$t('priceForMiddle')"
						class="w-1/2 ml-1"
					/>
				</div>
				<div class="site-works__input d-flex vx-col w-full md:w-1/3">
					<vs-checkbox
						v-model="work.is_enabled_for_senior"
						class="w-full md:w-1/2"
					>{{ $t('showForSenior') }}</vs-checkbox>
          			<vs-input
						v-model="work.senior_price"
            			type="number"
						name="senior-price"
						:label="$t('priceForSenior')"
						class="w-1/2 ml-1"
					/>
				</div>
			</div>
		</InfoRow>
	</div>
</template>

<script>
import InfoRow from "@/views/Sites/InfoRow";

export default {
	name: "SiteWorksVisibility",
	props: {
		modelWorks: { type: Array, default: () => [] },
		works: { type: Array, default: () => [] },
		levels: { type: Array, default: () => [] },
	},
	components: {
		InfoRow
	},
};
</script>

<style lang="scss" scoped>
.site-works {
	&__row {
		margin-top: 35px;

		&:first-child {
			margin-top: 0;
		}
	}

	@media screen and (max-width: 576px) {
		&__input {
			margin-top: 10px;
		}
	}
}
</style>
